import * as React from 'react';
import { Button } from '@cian/ui-kit';
import * as styles from './ToggleButton.css';

interface IToggleButtonProps {
  text: string;
  onClick(): void;
}

export const ToggleButton: React.FC<IToggleButtonProps> = props => {
  return (
    <div data-testid="PromosToggleButton" className={styles['container']}>
      <Button size="M" theme="fill_secondary" fullWidth={true} onClick={props.onClick}>
        {props.text}
      </Button>
    </div>
  );
};
